import { jsx } from 'react/jsx-runtime';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material';

const InlineAction = styled(MuiTypography) `
  color: ${({ theme }) => theme.palette.primary.main};
  cursor: pointer;
  max-height: 16px;
  margin: ${({ theme }) => theme.spacing(2, 0, 0, 0)};
  :hover {
    color: ${({ theme }) => theme.palette.primary.light};
  }
`;
const ToastInlineAction = ({ onClick, title }) => {
    return (jsx(InlineAction, Object.assign({ variant: "body2", onClick: onClick }, { children: title })));
};

export { ToastInlineAction as default };
//# sourceMappingURL=ToastInlineAction.js.map
